import { useEffect } from 'react'
import { BookOpen, TrendingUp, PiggyBank, CreditCard, Home, Target } from 'lucide-react'
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { PageHeader } from '@/components/layout'
import { useAppDispatch } from '@/store/hooks'
import { visitPage } from '@/store/slices/gamificationSlice'

const articles = [
  {
    title: 'How to Use This Financial Planning Tool',
    description: 'A comprehensive guide to getting the most out of your personal financial planner.',
    category: 'Getting Started',
    icon: BookOpen,
  },
  {
    title: 'Understanding Your Net Worth',
    description: 'Learn how to calculate and improve your net worth over time.',
    category: 'Basics',
    icon: TrendingUp,
  },
  {
    title: 'Building an Emergency Fund',
    description: 'Why you need 3-6 months of expenses saved and how to get there.',
    category: 'Savings',
    icon: PiggyBank,
  },
  {
    title: 'Debt Payoff Strategies',
    description: 'Compare the avalanche vs snowball methods and find what works for you.',
    category: 'Debt',
    icon: CreditCard,
  },
  {
    title: 'Real Estate as an Investment',
    description: 'Pros and cons of investing in rental properties and real estate.',
    category: 'Investing',
    icon: Home,
  },
  {
    title: 'Retirement Planning 101',
    description: 'Everything you need to know about 401(k)s, IRAs, and retirement savings.',
    category: 'Retirement',
    icon: Target,
  },
]

export default function Education() {
  const dispatch = useAppDispatch()

  // Track page visit for explorer achievement
  useEffect(() => {
    dispatch(visitPage('education'))
  }, [dispatch])

  return (
    <div className="space-y-6">
      <PageHeader 
        title="Financial Education" 
        description="Learn about personal finance and wealth building."
      />

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {articles.map((article) => (
          <Card key={article.title} className="cursor-pointer transition-all hover:shadow-md hover:border-primary/50">
            <CardHeader>
              <div className="flex items-center gap-2 mb-2">
                <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10">
                  <article.icon className="h-5 w-5 text-primary" />
                </div>
                <Badge variant="secondary">{article.category}</Badge>
              </div>
              <CardTitle className="text-lg">{article.title}</CardTitle>
              <CardDescription>{article.description}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>
    </div>
  )
}
